import { Theme } from "@mui/material/styles";
import { autocompleteClasses, radioClasses } from "@mui/material";

const rootButtonStyles = {
	alignItems: "flex-end",
	color: "var(--white-50)",
	display: "flex",
	padding: "6px 1rem",
	borderRadius: 0,
	fontSize: 14,
	fontWeight: "var(--font-weight-medium)",
	letterSpacing: "0.46px"
};

const textButtonStyles = {
	color: "var(--cwg-blue-900)",
	fontFamily: '"canada-type-gibson", sans-serif',
	fontWeight: "var(--font-weight-regular)",
	letterSpacing: "0.1px",
	alignItems: "center",
	lineHeight: "157%"
};

export const commonMuiTheme: Partial<Theme> = {
	components: {
		MuiAutocomplete: {
			styleOverrides: {
				root: {
					[`&.${autocompleteClasses.option}`]: {
						fontFamily: '"canada-type-gibson", sans-serif',
						fontWeight: "var(--font-weight-regular)"
					}
				}
			}
		},
		MuiButton: {
			variants: [
				{
					props: { variant: "outlined" },
					style: {
						...rootButtonStyles,
						color: "var(--cwg-blue-900)"
					}
				},
				{
					props: { variant: "contained" },
					style: {
						...rootButtonStyles,
						"&:hover": {
							backgroundColor: "var(--cwg-blue-700)"
						},
						backgroundColor: "var(--cwg-blue-900)"
					}
				},
				{
					props: { variant: "text" },
					style: {
						...textButtonStyles,
						textTransform: "capitalize"
					}
				}
			],
			styleOverrides: {}
		},
		MuiRadio: {
			styleOverrides: {
				root: {
					[`&.${radioClasses.checked}`]: {
						color: "var(--cwg-blue-900)"
					}
				}
			}
		},
		MuiFormHelperText: {
			styleOverrides: {
				root: {
					fontFamily: '"canada-type-gibson", sans-serif',
					fontWeight: "var(--font-weight-regular)",
					marginLeft: 0,
					marginRight: 0
				}
			}
		},
		MuiInputLabel: {
			styleOverrides: {
				root: {
					fontFamily: '"canada-type-gibson", sans-serif',
					fontWeight: "var(--font-weight-regular)"
				}
			}
		},
		MuiInputBase: {
			styleOverrides: {
				root: {
					fontFamily: '"canada-type-gibson", sans-serif',
					fontWeight: "var(--font-weight-regular)"
				}
			}
		},
		MuiTabs: {
			styleOverrides: {
				root: {
					color: "var(--cwg-blue-900)"
				},
				indicator: {
					backgroundColor: "var(--cwg-blue-900)"
				}
			}
		},
		MuiTab: {
			styleOverrides: {
				root: {
					"&.Mui-selected": {
						color: "var(--cwg-blue-900)"
					}
				}
			}
		}
	},
	palette: {
		text: {
			// These will be moved to the theme-specific MUI overrides and come from the fontColors object
			primary: "#565759",
			secondary: "rgba(0, 0, 0, 0.6)"
		}
	} as Theme["palette"],
	typography: {
		fontFamily: '"canada-type-gibson", sans-serif'
	} as Theme["typography"]
};
